import { atomWithStorage } from 'jotai/utils';
import { storage, type StorageKey } from '@/core/storage';

/**
 * A string-enum atom persisted in localStorage as the raw value (not JSON), so stored values
 * stay readable and compatible across versions. Unknown stored values fall back to `initial`.
 */
export function persistedEnumAtom<T extends string>(key: StorageKey, allowed: readonly T[], initial: T) {
  const isAllowed = (v: string | null): v is T => v != null && (allowed as readonly string[]).includes(v);
  return atomWithStorage<T>(
    key,
    initial,
    {
      getItem: (_, fallback) => {
        const v = storage.get(key);
        return isAllowed(v) ? v : fallback;
      },
      setItem: (_, v) => storage.set(key, v),
      removeItem: () => storage.remove(key),
    },
    { getOnInit: true },
  );
}
